<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Tickets
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SrNo. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="row">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rows </th>
                <td mat-cell *matCellDef="let element"> {{element.row || '-' | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="seat_no">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Seat </th>
                <td mat-cell *matCellDef="let element"> {{element.seat_no | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="assigned_to">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Assigned To </th>
                <td mat-cell *matCellDef="let element"> {{element.assigned_to | titlecase}} </td>
            </ng-container>

            <!-- <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" aria-label="Example icon button with a delete icon"
                        style="margin-left: 5px;" (click)="EditTicket(element.id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>


                </td>
            </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[50, 100, 200, 250]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>